import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  private error = new Subject<string>();

  constructor() { }    

  public addError = (error: string): void =>
    this.error.next(error);

  public getError = () =>
    this.error.asObservable();
}
